import { VideoTag } from 'lib/context';
import { User } from '../types';

export enum QuickVideoCategory {
  AI_ASSISTANT = 'ai_assistant',
  AI_VIN_REEL = 'ai_vin_reel',
}

export enum QuickVideoPartType {
  AI_VIN_REEL = 'ai_vin_reel',
  AI_ASSISTANT = 'ai_assistant',
  USER_VIDEO = 'user_video',
  DEALERSHIP_VIDEO = 'dealership_video',
}

export enum QuickVideoPartPosition {
  INTRO = 'intro',
  MAIN = 'main',
  OUTRO = 'outro',
}

export interface IQuickVideoTag {
  quickVideoTagId: number;
  userId: number;
  customerId: number;
  tag: string;
  // relations
  quickVideos?: IQuickVideo[];
  user?: User;
}

export interface IQuickVideoPart {
  quickVideoPartId: number;
  quickVideoId: number;
  partPosition: QuickVideoPartPosition;
  partType: QuickVideoPartType;
  description: string | null;
  quickVideoPartCustomerConfiguration?: IQuickVideoPartCustomerConfiguration;
  quickVideoPartUserConfigurations?: IQuickVideoPartUserConfiguration[];
}

// QuickVideo model
export interface IQuickVideo {
  quickVideoId: number;
  userId: number;
  customerId: number;
  emailContent: {
    subject: string;
    body: string;
    elements: [];
    signature: object;
  };
  expirationDropdownValue: string | null;
  expirationCustomDateValue: Date | null;
  smsText: string;
  sendEmail: number;
  sendSms: number;
  notifyWhenViewed: number;
  allowVideoReply: number;
  allowReactions: number;
  templateId: string;
  linksetId: string;
  overlayId: string;
  attachments: [];
  name: string;
  description: string;
  category: QuickVideoCategory;
  enabled: number;
  createdAt: Date;
  updatedAt: Date;
  generateEmailSmsContent: number;

  // relations
  quickVideoTags?: IQuickVideoTag[];
  quickVideoParts?: IQuickVideoPart[];
}

export interface IQuickVideoForm {
  name: string;
  description: string;
  category: QuickVideoCategory;
  sendEmail: number;
  sendSms: number;
  smsText: string;
  quickVideoParts: IQuickVideoPartForm[];
  generateEmailSmsContent: number;
  emailContent: {
    subject: string;
    body: string;
    elements: [];
    signature: object;
  };
}

export interface IExtendedQuickVideo extends IQuickVideo {
  thumbnailUrl: string;
}

export enum QuickVideoSortKeys {
  NAME = 'name',
  CATEGORY = 'category',
}

export interface IVideoDetails {
  id: number | string;
  title: string;
  thumbnail: string;
  recordDate: string;
  videoLength?: number;
  tags?: VideoTag[];
  views: number | string;
  user?: { firstName: string; lastName: string } | null;
}

export interface IQuickVideoPartForm {
  partType: QuickVideoPartType | '';
  partPosition: QuickVideoPartPosition;
  description: string;
  video?: IVideoDetails | null;
  quickVideoPartId?: number;
}

export interface IQuickVideoPartOption {
  value: QuickVideoPartType;
  label: string;
  type: QuickVideoPartPosition;
}

export interface IQuickVideoPartPositionOption {
  value: QuickVideoPartPosition;
  label: string;
  required: number;
}

export interface IQuickVideoCategoryOption {
  value: QuickVideoCategory;
  label: string;
}

interface IQuickVideoPartCustomerConfiguration {
  customerId: number;
  quickVideoId: number;
  quickVideoPartId: number;
  videoId: number;
  video: IVideoDetails;
  createdAt: string;
}

interface IQuickVideoPartUserConfiguration {
  userId: number;
  quickVideoId: number;
  quickVideoPartId: number;
  videoId: number;
  video: IVideoDetails;
  createdAt: string;
}

export interface IUpsertQuickVideoPart {
  partType: QuickVideoPartType | '';
  partPosition: QuickVideoPartPosition;
  videoId?: number;
  description: string;
  quickVideoPartId?: number;
}

export interface IUpsertQuickVideoBody {
  name: string;
  category: QuickVideoCategory;
  quickVideoParts: IUpsertQuickVideoPart[];
  sendEmail: number;
  sendSms: number;
  userId: number;
  customerId: number;
  generateEmailSmsContent: number;
}

export interface IQuickVideoPartTestSendForm {
  partType: QuickVideoPartType | '';
  partPosition: QuickVideoPartPosition;
  video?: IVideoDetails | null | undefined;
  description: string;
  quickVideoPartId: number;
}

export interface IQuickVideoTestSendForm {
  recipientName: string;
  inventoryItemId: number;
  recipientEmail: string;
  quickVideoParts: IQuickVideoPartTestSendForm[];
}

export enum QuickVideoEmailSmsValues {
  GENERATE_WITH_AI = 'Generate with AI',
  CUSTOMIZE_SCRIPT = 'Customize Script',
}
